import { useQuery, useMutation } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";

export function useGitHubConnect() {
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (userId?: string) => {
      const uid = userId ?? user?.id;
      const { data, error } = await supabase.functions.invoke("github-auth", {
        body: { user_id: uid },
      });
      if (error) throw error;
      return data as { url: string };
    },
  });
}

export type GitHubRepo = {
  full_name: string;
  name: string;
  private: boolean;
  updated_at: string;
  default_branch: string;
};

export function useGitHubRepos(enabled: boolean) {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["github-repos", user?.id],
    queryFn: async () => {
      if (!user) return [];
      const { data, error } = await supabase.functions.invoke(
        "list-github-repos",
        { body: { user_id: user.id } }
      );
      if (error) throw error;
      return (data as { repos: GitHubRepo[] }).repos;
    },
    enabled: !!user && enabled,
    staleTime: 5 * 60 * 1000, // cache for 5 min
  });
}
